module.exports = __webpack_public_path__ + "img/titlezh.6d26c981.png";